// ChatBox.jsx
import { useState, useContext } from "react";
import Chat from "./Chat";
import ChatWindow from "./ChatWindow";
import "./ChatBox.css";
import { ChatContext } from "../../context/ChatContext";
export default function ChatBox({chatList, sendMsg}) {
const [chatSelectedId, setChatSelectedId] = useState(null);
const {currentSelectedChat, setCurrentSelectedChat} = useContext(ChatContext)
const chatSelected = currentSelectedChat //chatList.find(c => c.chatID === chatSelectedId);

function SelectChat(chat) {
  
  if (!chat) return; // se não veio nenhum chat, sai logo

  // guarda o ID do chat selecionado
  setChatSelectedId(chat.chatID);

  // desestrutura os dados do chat
  const { chatID, chatUserList = [], chatLineList = [] } = chat;

  // monta uma string com informações
  let str = `chatID: ${chatID}\n`;
  str += `chatLineList count: ${chatLineList.length}\n`;

  chatUserList.forEach(u => {
    str += `name: ${u?.name} | uid: ${u?.uid}\n`;
  });

  // aqui você decide o que fazer com a string: logar, mostrar na tela etc.
  console.log(str);

  setCurrentSelectedChat(chat)
}


return (
  <div className="chat-container">

    {/* Sidebar */}
    <div className="chat-sidebar">
      {chatList?.map((chat, index) => (
        <Chat key={index} chat={chat} SelectChat={SelectChat} />
      ))}
    </div>

    {/* Chat */}
    <div className="chat-main">
      <ChatWindow chatSelected={chatSelected} sendMsg={sendMsg} />
    </div>

  </div>
);
}